import React, { FunctionComponent, useContext } from "react";
import UserAccessControlUtils from "../../utils/UserAccessControlUtils";
import { AuthContext } from "../../providers/AuthProvider";

type FeatureProtectedComponentProps = {
  requiredFeature: string;
};

const FeatureProtectedComponent: FunctionComponent<
  FeatureProtectedComponentProps
> = ({ requiredFeature, children }) => {
  const auth = useContext(AuthContext);
  return auth &&
    UserAccessControlUtils.hasFeature(auth.user_features, requiredFeature) ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  ) : (
    <div />
  );
};

export default FeatureProtectedComponent;
